export default __webpack_public_path__ + "static/media/search_green.b2bd97cb.svg";